import { firstOf, secondOf } from 'utils/arrays/elements.util';

const isEntryNotSame = (a, b) => firstOf(a) !== firstOf(b) || secondOf(a) !== secondOf(b);

export default isEntryNotSame;
